import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';
import { config } from '../../config/env';
import { post } from '../../utils/api.util';
import { BasketItemInput } from './types/basketService.types';
import {
  AlcoholProhibitedDurationsRequest,
  AlcoholProhibitedDurationsType,
} from '@mango-engineering/maknet-client-sdk/lib/shop/basket/types';
import appSdkClient from '../../utils/sdk';

export class BasketServiceWrapper {
  updateBasketItemPreview = async (basketItems: BasketItemInput[], idToken: string, region?: COUNTRY): Promise<any> => {
    try {
      const endPointURl = new URL(config.BASKET_API_ENDPOINT).origin.concat('/basket/api/v5/preview');
      const body = {
        basketItems,
        region,
      };
      const response = await post(endPointURl, body, idToken);
      if (response) {
        return { data: response, error: null };
      }
      throw new Error('Failed to update basket');
    } catch (error: any) {
      console.error('Error during update basketV5:', error);
      throw error;
    }
  };

  getBasketPreview = async (idToken: string, region?: COUNTRY): Promise<any> => {
    try {
      const endPointURl = new URL(config.BASKET_API_ENDPOINT).origin.concat('/basket/api/v5/preview');
      const body = {
        basketItems: [],
        region,
      };
      const response = await post(endPointURl, body, idToken);
      if (response) {
        return { data: response, error: null };
      }
      throw new Error('Failed to get basket preview');
    } catch (error: any) {
      console.error('Error during get basket preview:', error);
      throw error;
    }
  };

  async getAlcoholProhibitedDurations({
    storeCode,
    accessToken,
  }: AlcoholProhibitedDurationsRequest): Promise<AlcoholProhibitedDurationsType[]> {
    const response = await appSdkClient.shop.basket.getAlcoholProhibitedDurations({
      storeCode,
      accessToken,
    });
    return response.data || [];
  }
}

export const BasketService = new BasketServiceWrapper();
export default BasketService;
